import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-block',
  templateUrl: './welcome-block.component.html',
  styleUrls: ['./welcome-block.component.css']
})
export class WelcomeBlockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
